export default __webpack_public_path__ + "static/media/2462.dfab7cde.png";